module.exports = __webpack_public_path__ + "media/app/images/mobile-success@2x-825e316cc31d5250a4effcaa79db4036.png";